import { createApi } from '@reduxjs/toolkit/query/react'
import {fetchBaseQuery} from "@reduxjs/toolkit/query";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const sharedAnimeListsApi = createApi({
    reducerPath: 'sharedAnimeListsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_API_URL}/api/v2`,
        prepareHeaders: (headers) => {
            const code = process.env.REACT_APP_AZURE_KEY;

            if (!code) {
                console.error("No code in env file!");
                return;
            }

            headers.set('x-functions-key', code);

            return headers
        }
    }),
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    tagTypes: ["AnimeLists", "StatusCounts"],
    endpoints: (builder) => ({
        getSharedList: builder.query({
            query: ({slug, username}) => `${username}/anime-lists/shared/${slug}`,
            providesTags:  ['AnimeLists'],
        }),
        getSharedStatusCounts: builder.query({
            query: ({slug, username}) => `${username}/anime-lists/shared/${slug}/status/count`,
            providesTags: ["StatusCounts"]
        }),
        getSharedSelectOptions: builder.query({
            query: ({username}) => `${username}/shared/anime-lists/select-options`,
            providesTags: ["AnimeLists"]
        }),
    }),
})

export const {
    useLazyGetSharedListQuery,
    useLazyGetSharedStatusCountsQuery,
    useLazyGetSharedSelectOptionsQuery
} = sharedAnimeListsApi
